<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="curTitle"
    width="750px"
    :close-on-click-modal="false"
  >
    <div class="app-main-inner-row row-grid" style="min-height:350px;padding:0">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :config-module="configModule"
        style="width:100%"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <span slot="footer" style="padding-right:30px">
      <el-upload
        no="upload"
        action
        multiple
        :auto-upload="false"
        :show-file-list="false"
        :on-change="toChooseFile"
        style="float:left;margin-left:30px;margin-right:13px"
      >
        <el-button v-if="$checkPermission(['role_ContractManagement_branchContract']) || $checkPermission(['role_ContractManagement_departmentContract']) || !$checkPermission(['role_ContractManagement_releatedContract']) || this.$store.getters.isAdmin || model.createdBy === this.$store.getters.userId" type="primary">{{ $t('Partners.SelectFile') }}</el-button>
      </el-upload>
      <el-button v-if="$checkPermission(['role_ContractManagement_branchContract']) || $checkPermission(['role_ContractManagement_departmentContract']) || !$checkPermission(['role_ContractManagement_releatedContract']) || this.$store.getters.isAdmin || model.createdBy === this.$store.getters.userId" no="deleteFile" type="danger" style="float:left" @click="remove()">{{ $t('Partners.DeleteFile') }}</el-button>
      <el-button no="confirm" type="primary" @click="upload()">{{ $t('Partners.Confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>

    <!-- 文档类别弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="docTypeTree.visible"
      :title="$t('SeaExport.Edit')"
      width="320px"
      :close-on-click-modal="false"
      class="app-main-inner"
      append-to-body
    >
      <div class="app-main-inner-row">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="docTypeTree.gridOptions"
          :row-data="docTypeTree.rowData"
          style="min-width:300px;height:300px;padding-left:2px"
          @gridReady="params=>docTypeTree.gridApi=params.api"
        />
      </div>
      <span slot="footer" style="padding-right:30px">
        <el-button no="ok" type="primary" @click="saveDocType()">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancel2" @click="docTypeTree.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>

    <!-- 预览文件弹窗 -->
    <pre-view-file-dialog
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :file="previewFileData.file"
      :can-maximize="true"
      @close="closePreviewDialog"
    />
  </el-dialog>
</template>

<script>
import pdf from 'vue-pdf'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import { AutoIncrementNum, DocumentManage } from '@/utils/commonUtil'
import { cacheName, cache } from '@/utils/cacheManager'
import { findBusinessDocument, execBatchSave } from '@/api/seaExport/businessDocument'
import { uploadStorage, deleteFile } from '@/api/storage'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'
import preViewFileDialog from '@/components/Cargo/Common/preViewFileCommonDialog'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
export default {
  name: 'ContractUploadFile',
  components: { pdf, CargoDialog, preViewFileDialog },
  props: {
    visible: { type: Boolean, required: true },
    documentCategory: { type: String, default: '0' },
    model: { type: Object, required: true },
    title: { type: String, required: true },
    configModule: { type: String, required: false, default: '' },
    lob: { type: String, default: '' }
  },
  data() {
    return {
      innerVisible: false,
      user: {},
      storageURL: '',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: this.itemClickHandler
      },
      selectedFile: null,
      columnDefs: [
        {
          headerName: this.$t('Partners.FileName'),
          field: 'fileName',
          suppressMenu: true,
          width: 175
        },
        {
          headerName: this.$t('Partners.FileType'),
          field: 'fileType',
          width: 120
        },
        {
          headerName: this.$t('Partners.FileSize'),
          field: 'fileSize',
          suppressMenu: true,
          width: 120,
          valueFormatter: params => {
            return params.value ? (params.value / 1024).toFixed(1) + 'KB' : ''
          }
        },
        {
          headerName: this.$t('FileHistory.operation'),
          field: '',
          colId: 'operation',
          width: 120,
          cellRenderer: params => {
            if (params.data.fileId) {
              let preview = ''
              const fileStr = params.data.fileName
              const location = fileStr.lastIndexOf('.')
              const type = fileStr.substring(location + 1, fileStr.length)
              if (type === 'jpg' || type === 'png' || type === 'jpeg' || type === 'gif' || type === 'webp' || type === 'pdf' ||
              type === 'doc' || type === 'docx' || type === 'xls' || type === 'xlsx') {
                const handlePreviewFile = this.documentManage.getPath('handlePreviewFile')
                preview = `<a onclick="${handlePreviewFile}('${params.data.fileId}')" style="color:blue">${this.$t('FileHistory.preview')}</a>`
              }
              return `<a href="${URL.common.findByFileId}/${params.data.fileId}?sessionId=${this.user.sessionId}" target="_blank" style="color:blue">
                    ${this.$t('CargoMsg.Cargo_Download')}
                    </a>` + preview
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('Partners.Uploader'),
          field: 'createdBy',
          width: 120,
          valueFormatter: params => {
            if (!params.value) return ''
            const name = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
            if (name) {
              return name
            } else {
              return params.data.createByName
            }
          }
        },
        {
          headerName: this.$t('Partners.UploadTime'),
          field: 'dateCreated',
          width: 120,
          valueFormatter: params => {
            return params.value ? ColumnUtils.dateLabelFunc(params.value) : ''
          }
        },
        {
          headerName: this.$t('Partners.UploadProgress'),
          field: 'fileId',
          width: 120,
          cellRenderer: params => {
            if (params.value) {
              return `<span style="color:blue">${this.$t('Message.Uploaded')}</span>`
            }
            if (this.uploading) {
              return this.$t('Message.Uploaded')
            }
            return this.$t('Message.Waiting')
          }
        },
        {
          headerName: this.$t('Partners.DocumentType'),
          field: 'fileCategory',
          colId: 'fileCategory',
          cellRenderer: params => {
            const fileCategories = params.value ? params.value.split(',') : []
            const fileCategoryLabels = []
            for (const fileCategory in fileCategories) {
              fileCategoryLabels.push(this.docTypeMap.get(fileCategories[fileCategory].toUpperCase()))
            }
            const fileCategoryLabel = fileCategoryLabels.join(',')
            const methodPath = this.documentManage.getPath('showDocTypeTree')
            return `<div onclick="${methodPath}(${
              params.data.seq
            })" style="cursor:pointer">${fileCategoryLabel || '&nbsp;'}</div>`
          },
          width: 120
        }
      ],
      rowData: [],
      gridApi: null,
      docTypeTree: {
        visible: false,
        gridOptions: {
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('SeaExport.DocumentType'),
            width: 300,
            suppressMenu: true,
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: params => {
                if (params.data.type === 2) {
                  const iconName = params.data.checked
                    ? 'checkbox-checked'
                    : 'checkbox-notChecked'
                  return `<svg class="svg-icon" aria-hidden="true" style="height:1.2em;width:1.2em;vertical-align:text-bottom;">
                            <use xlink:href="#icon-${iconName}"></use>
                          </svg>
                          &nbsp;${params.data.chineseName}`
                }
                return params.data.chineseName
              }
            },
            onCellClicked: params => {
              if (params.data.type === 2) {
                const checked = !params.data.checked
                params.data.checked = checked
                params.api.refreshCells({ force: true })
              }
            }
          },
          columnDefs: [],
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      docTypeMap: new Map(),
      autoIncrementNum: new AutoIncrementNum(),
      documentManage: new DocumentManage(),
      uploading: false,
      deleteFileItems: [], //  删除的文件 Business_Document documentId
      deleteItems: [], //  删除的文件 Business_Document uuid
      updateItems: [], //  修改的文件
      addItems: [], //  新增的文件
      // 图片预览参数
      previewFileData: {
        visible: false,
        file: null
      }
    }
  },
  computed: {
    curTitle() {
      return this.title || this.$t('CargoMsg.Cargo_Attachment')
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.initData()
        }
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
        this.deleteItems = []
        this.addItems = []
        this.updateItems = []
        this.$emit('uploadDone')
      }
      this.$emit('update:visible', newVal)
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showDocTypeTree', function(seq) {
      context.showDocTypeTree(seq)
    })
    this.documentManage.set('handlePreviewFile', function(value) {
      context.handlePreviewFile(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async initData() {
      await this.buildDocTypeTree()
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.storageURL = cache.config.get('StorageURL')
      await this.toQuery()
    },
    async toQuery() {
      if (this.model) {
        let item = { businessId: this.model.uuid }
        // 如果有关联合同，文件一起查出来
        if (this.model.contractBatchNo && this.model.associationUuidList) {
          item = { businessIds: [...this.model.associationUuidList, this.model.contractBatchNo] }
        }
        await findBusinessDocument(item).then(res => {
          this.rowData = Array.from(res.data, p => {
            return {
              seq: this.autoIncrementNum.getNextNum(),
              uuid: p.uuid,
              fileId: p.documentId,
              fileName: p.fileName,
              fileType: p.fileType || '',
              fileSize: p.fileSize,
              createdBy: p.createdBy,
              dateCreated: p.dateCreated,
              documentId: p.documentId,
              createByName: p.createByName,
              fileCategory: p.fileCategory
            }
          })
        })
      }
    },
    async buildDocTypeTree() {
      if (this.lob) {
        await getDocCategoryTypeTreeByLob({
          constructLobParent: false,
          lob: this.lob
        }).then(res => {
          const data = res.data.filter(p => {
            const pathArr = p.path.split(',')
            if (p.type === 1) {
              return pathArr.length === 1
            }
            if (p.type === 2) {
              return pathArr.length > 1
            }
            return false
          })
          data.forEach(item => {
            item.checked = false
            if (item.type === 2) {
              this.docTypeMap.set(item.code.toUpperCase(), item.chineseName)
            }
          })
          this.docTypeTree.rowData = data
        })
      } else {
        this.docTypeTree.rowData = []
      }
    },
    toChooseFile(file) {
      const fileName = file.name
      const fileType = fileName.substr(fileName.lastIndexOf('.') + 1)
      const params = { file: file.raw }
      if (this.model && this.model.contractBatchNo) {
        params.uuid = this.model.contractBatchNo
      } else {
        params.uuid = this.model.uuid
      }
      params.createdBy = this.user.userId
      params.createChineseName = this.user.chineseName
      params.createEnglishName = this.user.englishName
      this.rowData.push({
        seq: this.autoIncrementNum.getNextNum(),
        uuid: '',
        fileId: '',
        fileName,
        fileType,
        fileSize: file.size,
        fileCategory: '',
        fileCategoryLabel: '',
        params
      })
    },
    remove() {
      if (!this.selectedFile) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(
        this.$t('common.tips.confirmDelete'),
        this.$t('common.tips.prompt'),
        {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }
      ).then(() => {
        const row = this.selectedFile
        if (row.fileId) {
          // 记录移除的 uuid
          this.deleteItems.push(row.uuid)
          this.deleteFileItems.push(row.fileId)
        }
        this.rowData = this.rowData.filter(p => p.seq !== row.seq)
      }).catch(() => {})
    },
    async upload() {
      const rows = this.rowData.filter(p => !p.fileId)
      this.updateItems = this.rowData.filter(p => p.update)
      if (rows.length === 0 && this.deleteItems.length === 0 && this.updateItems.length === 0) {
        this.innerVisible = false
        return
      }
      const loading = getLoading4Cxt(this)
      this.uploading = true
      this.gridApi.refreshCells({ force: true })
      try {
        await Promise.all(
          Array.from(rows, p => {
            const params = p.params
            if (this.model.jobNo) {
              params.jobNo = this.model.jobNo
            }
            if (this.model.mbl) {
              params.mbl = this.model.mbl
            }
            params.documentType = p.fileCategory
            params.documentName = p.fileCategoryLabel
            params.isShared = 'false'
            params.op = 'false'
            params.sales = 'false'
            params.all = 'false'
            params.customer = 'false'
            params.consignee = 'false'
            params.shipper = 'false'
            params.destinationAgent = 'false'
            params.bookingAgent = 'false'
            params.contractUuid = this.model.uuid
            return uploadStorage(params).then(res => {
              p.fileId = res.data
              // 记录添加上传的
              this.addItem(p)
            })
          })
        )
        // 确认时 处理删除的文件
        for (const fileId of this.deleteItems) {
          const success = await deleteFile(fileId).then(res => res.data)
          if (success !== 'success') {
            this.$message.warning(this.$t('queryJob.failedDeleteFile'))
            return
          }
        }
        // 调用后端保存api
        const data = {
          addItems: this.addItems,
          deleteItems: this.deleteItems,
          updateItems: this.updateItems
        }
        await execBatchSave(data)
        this.innerVisible = false
      } catch {
        const uploadSuccessCount = rows.filter(p => p.fileId).length
        const uploadFailCount = rows.filter(p => !p.fileId).length
        await this.$confirm(
          this.$t('queryJob.Upload0UploadFailed0', [uploadSuccessCount, uploadFailCount]),
          this.$t('common.tips.prompt'),
          {
            showClose: false,
            confirmButtonText: this.$t('common.btn.ok'),
            showCancelButton: false,
            type: 'warning'
          }
        )
      } finally {
        this.uploading = false
        loading.close()
        this.gridApi.refreshCells({ force: true })
        this.$emit('onUploadDone')
      }
    },
    addItem(fileUpload) {
      // :Business_Document = new Business_Document();
      const doc = {}
      doc.fileName = fileUpload.fileName
      doc.fileSize = fileUpload.fileSize
      doc.fileType = fileUpload.fileType
      doc.documentCategory = this.documentCategory
      doc.fileCategory = 'other'
      doc.fileCategory = fileUpload.fileCategory
      doc.businessId = this.model.uuid
      doc.documentId = fileUpload.fileId
      this.addItems.push(doc)
    },
    // 行选择事件
    itemClickHandler(event) {
      if (!event.data) {
        return
      }
      this.selectedFile = event.data
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedFile = node.data
          }
        })
      }
    },
    showDocTypeTree(seq) {
      const rows = this.rowData.filter(p => p.seq === seq)
      if (rows.length === 0) {
        return
      }
      const fileCategory = rows[0].fileCategory.toUpperCase()
      const fileCategories = fileCategory ? fileCategory.split(',') : []
      this.docTypeTree.rowData.forEach(item => {
        if (fileCategories.length > 0 && fileCategories.includes(item.code.toUpperCase())) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
      this.docTypeTree.visible = true
    },
    // 选择文档类型之后
    saveDocType() {
      const currentRow = this.selectedFile // this.gridApi.getSelectedRows()[0]
      const docTypeRows = this.docTypeTree.rowData.filter(
        p => p.type === 2 && p.checked
      )
      if (docTypeRows.length > 0) {
        let codes = ''
        let labels = ''
        for (const item of docTypeRows) {
          if (codes) {
            codes += ','
          }
          codes += item.code
          if (labels) {
            labels += ','
          }
          labels += item.chineseName
        }
        currentRow.fileCategory = codes
        currentRow.fileCategoryLabel = labels
      } else {
        currentRow.fileCategory = ''
        currentRow.fileCategoryLabel = ''
      }
      if (currentRow.fileId) currentRow.update = true
      this.gridApi.refreshCells({ force: true })
      this.docTypeTree.visible = false
    },
    async handlePreviewFile(value) {
      const fileObject = this.rowData.find(x => x.fileId === value)
      this.previewFileData.file = fileObject || null
      this.previewFileData.visible = true
    },
    // 获取文件后缀名
    getFileType(fileName) {
      const arr = fileName.split('.')
      if (arr.length > 1) {
        return arr[arr.length - 1].toLowerCase()
      }
      return ''
    },
    closePreviewDialog() {
      this.previewFileData.file = null
      this.previewFileData.visible = false
    }
  }
}
</script>

<style scoped>
.not-click {
  pointer-events: none;
}
</style>
<style lang="scss" scoped>
</style>
